import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@material-ui/core";

import { ChartSellIn } from "components/Charts/ChartSellIn";
import BigNumberCard from "components/_refactor/card/big-number";

export default function CardClientBillingOrders({ title, period, data }) {
  const initialDate = period?.initialDate;
  const finalDate = period?.finalDate;

  const formattedInitialDate = initialDate
    ?.split("-")
    .reverse()
    .join()
    .replaceAll(",", "/");
  const formattedFinalDate = finalDate
    ?.split("-")
    .reverse()
    .join()
    .replaceAll(",", "/");

  const periodString = `: ${formattedInitialDate} à ${formattedFinalDate}`;
  const cardTitle = period ? title + periodString : title;

  const titlesPageRedirectUrl = "/admin/relatorio-acompanhamento-titulos?";
  const periodQueryString = `dtInit=${initialDate}&dtFim=${finalDate}`;
  const expiredTitlesQueryString = "&expired=true";

  const expiredTitlesUrl =
    titlesPageRedirectUrl + periodQueryString + expiredTitlesQueryString;

  return (
    <Card>
      <CardHeader
        title={cardTitle}
        titleTypographyProps={{
          marginBottom: "0!important",
          variant: "h3",
          borderBottom: "2px solid #c0502a",
        }}
      />
      <CardContent>
        <Grid container>
          {data.charts?.length > 0 &&
            data?.charts?.map((item, i) => (
              <Grid item xl={4} lg={6} sm={12} key={i}>
                <a href={item?.openUrl && item?.openrl}>
                  <BigNumberCard value={item?.total} title={item?.title} />
                </a>
                {!item?.noChart && (
                  <Box height="275px" width="100%">
                    <ChartSellIn data={item?.categories} />
                  </Box>
                )}
              </Grid>
            ))}
          <Grid item xl={3} xs={12}>
            <Grid container>
              {data.overdueAmount && (
                <Grid item xs={12}>
                  <BigNumberCard
                    title="Valor em atraso"
                    value={data.overdueAmount}
                  />
                </Grid>
              )}
              {data.averageTicket && (
                <Grid item xs={12}>
                  <BigNumberCard
                    title="Ticket médio"
                    value={data.averageTicket}
                  />
                </Grid>
              )}
              {data.expiredTitles && (
                <Grid item xs={12}>
                  <a href={expiredTitlesUrl}>
                    <BigNumberCard
                      title="Títulos vencidos"
                      value={data.expiredTitles}
                    />
                  </a>
                </Grid>
              )}
            </Grid>
          </Grid>

          {data.bestSellerProducts?.length > 0 && (
            <Grid item xl={5} sm={12}>
              <Typography
                variant="h2"
                component={Box}
                style={{ marginTop: "1rem", color: "#000" }}
              >
                Produtos mais vendidos
              </Typography>
              <Box height="275px">
                <ChartSellIn data={data.bestSellerProducts} isHorizontal />
              </Box>
            </Grid>
          )}
        </Grid>

        <Grid container style={{ marginTop: "20px" }}></Grid>
      </CardContent>
    </Card>
  );
}
